import React from 'react';
import ReactDOM from 'react-dom/client';
import './scripts/mobile-menu.js';
import './scripts/user-verification.js';
import './scripts/singleShare';
import './scripts/orgClaim';
import './scripts/cityFilter';
import './scripts/personFormAccordion';
import './scripts/orgFormAccordion';
import './scripts/spaceFormAccordion';
import './scripts/projectFormAccordion';
import './scripts/activityFormAccordion';
import './scripts/resourceFormAccordion';
import './scripts/administrationFormAccordion';
import './scripts/activitySignupFormAccordion';
import OrgTable from './components/OrgTable';
import ProjectTable from './components/ProjectTable';
import ActivityTable from './components/ActivityTable';
import MyActivitiesTable from './components/MyActivitiesTable';
import PendingOrgsTable from './components/PendingOrgsTable';
import SpaceTable from './components/SpaceTable';
import AdministrationTable from './components/AdministrationTable';
import PersonTable from './components/PersonTable';
import PersonImporter from './components/PersonImporter';
import OrgImporter from './components/OrgImporter';
import SpaceImporter from './components/SpaceImporter';
import AdministrationImporter from './components/AdministrationImporter';
import GeocodeRunner from './components/GeocodeRunner';
import ResourceTable from './components/ResourceTable';
import MapView from './components/MapView';

const orgEl = document.getElementById( 'crm-org-table' );
if ( orgEl ) {
	ReactDOM.createRoot( orgEl ).render( <OrgTable /> );
}

const projectEl = document.getElementById( 'crm-project-table' );
if ( projectEl ) {
	ReactDOM.createRoot( projectEl ).render( <ProjectTable /> );
}

const activityEl = document.getElementById( 'crm-activity-table' );
if ( activityEl ) {
	ReactDOM.createRoot( activityEl ).render( <ActivityTable /> );
}

const myActivitiesEl = document.getElementById( 'crm-my-activities-table' );
if ( myActivitiesEl ) {
	ReactDOM.createRoot( myActivitiesEl ).render( <MyActivitiesTable /> );
}

const pendingOrgsEl = document.getElementById( 'crm-pending-orgs-table' );
if ( pendingOrgsEl ) {
	ReactDOM.createRoot( pendingOrgsEl ).render( <PendingOrgsTable /> );
}

const spaceEl = document.getElementById( 'crm-space-table' );
if ( spaceEl ) {
	ReactDOM.createRoot( spaceEl ).render( <SpaceTable /> );
}

const administrationEl = document.getElementById( 'crm-administration-table' );
if ( administrationEl ) {
	ReactDOM.createRoot( administrationEl ).render( <AdministrationTable /> );
}

const personEl = document.getElementById( 'crm-person-table' );
if ( personEl ) {
	ReactDOM.createRoot( personEl ).render( <PersonTable /> );
}

const personImporterEl = document.getElementById( 'crm-person-importer' );
if ( personImporterEl ) {
	ReactDOM.createRoot( personImporterEl ).render( <PersonImporter /> );
}

const orgImporterEl = document.getElementById( 'crm-org-importer' );
if ( orgImporterEl ) {
	ReactDOM.createRoot( orgImporterEl ).render( <OrgImporter /> );
}

const spaceImporterEl = document.getElementById( 'crm-space-importer' );
if ( spaceImporterEl ) {
	ReactDOM.createRoot( spaceImporterEl ).render( <SpaceImporter /> );
}

const administrationImporterEl = document.getElementById(
	'crm-administration-importer'
);
if ( administrationImporterEl ) {
	ReactDOM.createRoot( administrationImporterEl ).render(
		<AdministrationImporter />
	);
}

const spaceGeocoderEl = document.getElementById( 'crm-space-geocoder' );
if ( spaceGeocoderEl ) {
	ReactDOM.createRoot( spaceGeocoderEl ).render(
		<GeocodeRunner type="space" />
	);
}

const orgGeocoderEl = document.getElementById( 'crm-org-geocoder' );
if ( orgGeocoderEl ) {
	ReactDOM.createRoot( orgGeocoderEl ).render( <GeocodeRunner type="org" /> );
}

const resourceEl = document.getElementById( 'crm-resource-table' );
if ( resourceEl ) {
	ReactDOM.createRoot( resourceEl ).render( <ResourceTable /> );
}

const mapEl = document.getElementById( 'crm-map' );
if ( mapEl ) {
	ReactDOM.createRoot( mapEl ).render( <MapView /> );
}
